import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import ActiveEmployeesTable from "./table";
import { query, collection, where, getDocs } from "firebase/firestore";
import { db } from "src/firebase";
import { IEmployee } from "src/types/employees";
import { useRecoilValue } from "recoil";
import { authState } from "src/store/auth";
import { chunkArray } from "src/utils";
import { employeeRoleFlags } from "../add-edit-employee/constants";

const ActiveEmployeesPage = () => {
  const [activeUsers, setActiveUsers] = useState<IEmployee[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const auth = useRecoilValue(authState);
  const { user } = auth;
  const roleType = user?.roleType;
  const locationsIdList = user?.allowedLocationsId ?? [];

  const fetchActiveUsers = async () => {
    try {
      setIsLoading(true);
      let snapshots = [];
      // Not Admin → apply locations filter with chunking
      if (false) {
        //roleType !== "Admin" && locationsIdList?.length
        const chunks = chunkArray(locationsIdList, 10);

        const queries = chunks.map((chunk) =>
          getDocs(
            query(
              collection(db, "users"),
              where("isUserActive", "==", true),
              where("allowedLocationsId", "array-contains-any", chunk),
            ),
          ),
        );
        snapshots = await Promise.all(queries);
      }

      // Admin → ignore locations
      else {
        const snapshot = await getDocs(
          query(collection(db, "users"), where("isUserActive", "==", true)),
        );
        snapshots = [snapshot]; // keep same structure
      }

      // Deduplicate
      const usersMap = new Map<string, IEmployee>();
      snapshots.forEach((snapshot) => {
        snapshot.docs.forEach((doc) => {
          if (!usersMap.has(doc.id)) {
            usersMap.set(doc.id, {
              ...(doc.data() as IEmployee),
              id: doc.id,
            });
          }
        });
      });

      setActiveUsers(Array.from(usersMap.values()));
    } catch (error) {
      console.error("Error fetching active users:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchActiveUsers();
  }, [roleType]);

  // Filter out client-only users, as the same user can be both a client and an admin at the same time.
  const activeEmployees = activeUsers.filter((user) =>
    employeeRoleFlags.some((role) => user[role]),
  );

  console.log({ activeEmployees });

  return (
    <Box p={"30px"} data-testid="active-employees-page">
      <Typography mb={4} fontSize={"22px"} fontWeight={600}>
        Active Accounts
      </Typography>
      <ActiveEmployeesTable
        rowsList={activeEmployees}
        isLoading={isLoading}
        fetchActiveUsers={fetchActiveUsers}
      />
    </Box>
  );
};

export default ActiveEmployeesPage;
